import { async_lazy, LazyAsync } from "../../../../lib/Lazy";
import { NeedleImage } from "../../../../lib/alt1/capture";
import { Vector2 } from "../../../../lib/math";
import { util } from "../../../../lib/util/util";
import { FakeLodash } from "../../../../lib/coreutil/FakeLodash";
var rgbSimilarity = util.rgbSimilarity;
export class CapturedSliderInterface {
    constructor(image, image_includes_checkbox, reader) {
        this.image = image;
        this.image_includes_checkbox = image_includes_checkbox;
        this.reader = reader;
        this._puzzle = null;
        if (image_includes_checkbox) {
            this.body = image.getSubSection({
                origin: { x: -CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL.x, y: 0 },
                size: { ...CapturedSliderInterface.PUZZLE_SIZE }
            });
        }
        else {
            this.body = image;
        }
    }
    isInvertedArrowKeyCheckboxEnabled() {
        if (!this.image_includes_checkbox)
            return false;
        const pixel = this.image.getSubSection({
            origin: { x: 0, y: CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL.y },
            size: { x: 1, y: 1 }
        }).getData();
        // log().log("Slider", "", this.image.getData())
        return rgbSimilarity(CapturedSliderInterface.CHECKMARK_COLOR, pixel.getPixel(0, 0)) > 0.8;
    }
    screenRectangle(include_checkbox) {
        if (include_checkbox == this.image_includes_checkbox) {
            return this.image.screenRectangle();
        }
        else if (include_checkbox) {
            const body_rect = FakeLodash.cloneDeep(this.body.screenRectangle());
            body_rect.origin.x += CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL.x;
            body_rect.size.x += -CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL.x;
            return body_rect;
        }
        else {
            return this.body.screenRectangle();
        }
    }
    recapture(include_checkbox, image) {
        return new CapturedSliderInterface(image.getScreenSection(this.screenRectangle(include_checkbox)), include_checkbox, this.reader);
    }
    getPuzzle(known_theme = undefined) {
        if (!this._puzzle && this.reader) {
            this._puzzle = this.reader.identify(this.body.getData(), known_theme);
        }
        return this._puzzle;
    }
}
(function (CapturedSliderInterface) {
    let Finder;
    (function (Finder) {
        const SLIDER_FINDER_DEBUG = false;
        Finder.instance = async_lazy(async () => {
            const anchor = (await CapturedSliderInterface.anchors.get()).eoc_x;
            return new class {
                find(img, include_inverted_arrow_checkmark, reader) {
                    const positions = img.findNeedle(anchor);
                    if (SLIDER_FINDER_DEBUG)
                        console.log(`Slider anchor positions: ${positions.length}`);
                    if (positions.length > 0) {
                        const body_rect = {
                            origin: Vector2.add(positions[0].relativeRectangle().origin, CapturedSliderInterface.TL_TILE_FROM_X_OFFSET),
                            size: { ...CapturedSliderInterface.PUZZLE_SIZE }
                        };
                        if (include_inverted_arrow_checkmark) {
                            body_rect.origin.x += CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL.x;
                            body_rect.size.x += -CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL.x;
                        }
                        return new CapturedSliderInterface(positions[0].parent.getSubSection(body_rect), include_inverted_arrow_checkmark, reader);
                    }
                    return null;
                }
            };
        });
    })(Finder = CapturedSliderInterface.Finder || (CapturedSliderInterface.Finder = {}));
    CapturedSliderInterface.TL_TILE_FROM_X_OFFSET = { x: -298, y: 14 };
    CapturedSliderInterface.INVERTED_CHECKBOX_OFFSET_FROM_TL = { x: -169, y: 225 };
    CapturedSliderInterface.PUZZLE_SIZE = { x: 273, y: 273 };
    CapturedSliderInterface.CHECKMARK_COLOR = [209, 171, 101];
    CapturedSliderInterface.anchors = new LazyAsync(async () => {
        return {
            eoc_x: await NeedleImage.fromURL("/alt1anchors/sliders/eoc_x.png"),
        };
    });
})(CapturedSliderInterface || (CapturedSliderInterface = {}));
